import { Component, inject } from '@angular/core';
import { AdvancedCommerceConfigStore } from '@df/module-advanced-commerce/store/advanced-commerce-config.store';
import { AdvancedCommerceSearchViewComponent } from '../module/advanced-commerce/search/view/advanced-commerce-search-view.component';
import { SearchViewComponent } from './ui/search-view.component';

// Define a component that will dynamically select either AdvancedCommerceSearchViewComponent or SearchViewComponent based on the result from apiConfigResolver
@Component({
    selector: 'dynamic-search',
    template: `
        @if (acEnabled) {
            <advanced-commerce-search-view></advanced-commerce-search-view>
        } @else {
            <search-view></search-view>
        }
    `,
    standalone: true,
    imports: [AdvancedCommerceSearchViewComponent, SearchViewComponent]
})
export class DynamicSearchComponent {
    protected acEnabled = !!inject(AdvancedCommerceConfigStore)?.config()?.enabled;
}
